import { ReactElement } from 'react';
import { useSearchParams } from 'react-router-dom';

import { LicenseService, useApiGetter, useRoutes } from '@localstack/services';

import { ToolkitExtensionRedirect } from '~/views/customer/Redirect/ToolkitExtensionRedirect';
import { AuthRequestRedirect } from '~/views/customer/Redirect/AuthRequestRedirect';
import { KnownRedirects } from '~/views/customer/Redirect/constants';
import { AppRoute } from '~/config';

export type ConsoleRedirectProps = {
  token?: string;
  isLoading: boolean;
};

const REDIRECT_NAME_QUERY_PARAM = 'name';

const REDIRECT_COMPONENT_MAP = {
  [KnownRedirects.VSCode]: ToolkitExtensionRedirect,
  [KnownRedirects.VSCodeInsiders]: ToolkitExtensionRedirect,
  [KnownRedirects.Windsurf]: ToolkitExtensionRedirect,
  [KnownRedirects.Kiro]: ToolkitExtensionRedirect,
  [KnownRedirects.Cursor]: ToolkitExtensionRedirect,
  [KnownRedirects.Antigravity]: ToolkitExtensionRedirect,
  [KnownRedirects.AuthRequest]: AuthRequestRedirect,
};

/**
This page serves as an entrypoint to redirect to other tools
It's responsible for determining which flow / page should be triggered
**/
export const Redirect = (): ReactElement => {
  const { goto } = useRoutes();
  const [searchParams] = useSearchParams();
  const integrationValue = searchParams.get(REDIRECT_NAME_QUERY_PARAM)?.toLowerCase();

  const RenderingComponent = REDIRECT_COMPONENT_MAP[integrationValue as KnownRedirects];

  const { data: authToken, isLoading: isAuthTokenLoading } = useApiGetter(LicenseService, 'getWorkspaceToken', []);

  if (RenderingComponent) {
    return <RenderingComponent token={authToken?.token} isLoading={isAuthTokenLoading} />;
  } else {
    goto(AppRoute.GETTING_STARTED);
    return <></>;
  }
};
